import { cn } from "@/lib/utils";
import { FC } from "react";

//src is one of Icons in Assests.icons.
const CircleIcon: FC<{src: string, alt?: string, className?: string, iconClassName?: string}> = ({src, alt, className, iconClassName}) => (
    <div className={cn("flex p-2 w-12 h-12 md:w-[84px] md:h-[84px] bg-tertiary aspect-square rounded-full justify-center align-center items-center", className)}>
        <img src={src} 
            alt={alt}
            className={cn("max-w-[32px] max-h-[32px] md:max-w-[40px] md:max-h-[40px]  object-contain", iconClassName)}
        />
    </div>
)

export default CircleIcon;